import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tokenField"];

  updateToken() {
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    if (this.hasTokenFieldTarget && csrfToken) {
      this.tokenFieldTarget.value = csrfToken;
    }
  }
}
